export default Object.freeze({
  INITIAL: undefined,
  PENDING: 'PENDING',
  DONE: 'DONE'
})
